import { DocumentPreviewType, IDocumentFile } from '@aston/foundation';
import { AppConstants } from 'apps/console/src/app/app.constants';

export function previewType(document: IDocumentFile) {
	if (AppConstants.IMAGE_PREVIEW_MATCH.test(document.mimeType)) {
		return DocumentPreviewType.Image;
	}
	if (AppConstants.IFRAME_PREVIEW_MATCH.test(document.mimeType)) {
		return DocumentPreviewType.Iframe;
	}
	return DocumentPreviewType.Download;
}
